module.exports = __webpack_public_path__ + "img/dr_mallath_photo.5784a36b.png";